var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAkaswap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_7_2",
    "data-name": "Component 7 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.198,
    height: 55.198,
    viewBox: "0 0 55.198 55.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0.246 0.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M26.753,0h1.692A26.753,26.753,0,0,1,55.2,26.753v1.692A26.753,26.753,0,0,1,28.445,55.2H26.753A26.753,26.753,0,0,1,0,28.445V26.753A26.753,26.753,0,0,1,26.753,0Z",
    transform: "translate(-0.246 -0.107)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M1456.858-115.633c1.769-2.276,3.289-4.248,4.823-6.2,4.936-6.29,9.89-12.561,14.8-18.876a2.366,2.366,0,0,1,2.177-1.124c1.357.086,2.722.022,4.161.022v26.675h-4.372v-21.644c-.607.733-.989,1.162-1.339,1.622-4.6,6.047-9.223,12.077-13.779,18.17a2.736,2.736,0,0,1-2.645,1.382C1459.532-115.722,1458.366-115.633,1456.858-115.633Z",
    transform: "translate(-1444.104 155.735)",
    fill: "#f7f7f7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkaswap);
export default __webpack_public_path__ + "static/media/akaswap.43c1a8d9.svg";
export { ForwardRef as ReactComponent };